import { Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild, ViewEncapsulation, inject } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from "@angular/forms";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { Data, RouterLink } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { FirebaseFileUploadService } from "@core/firebase-fileupload.service";
import { ActionSheetController, IonicModule, ModalController } from "@ionic/angular";
import { map, startWith, switchMap, take, takeUntil } from "rxjs/operators";
import { CommonVariable, FB_PROFILE_PIC_BASE_URL } from "src/app/app.constants";
import { TermsAndConditionPage } from "../terms-and-condition/terms-and-condition.page";
// import { CameraResultType } from "@capacitor/camera";
import { AsyncPipe, NgClass, UpperCasePipe } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CameraResultType } from "@capacitor/camera";
import { Plugins } from "@capacitor/core/dist";
import { CaptchaService } from "@core/captcha.service";
import { UtilityService } from "@core/utility.service";
import { AuthCredentials } from "@interfaces/auth-credentials.i";
import { FlagInterface, Language, allLanguageCodes, defaultLanguage } from "@interfaces/translation-interface";
import { VoucherClaimResult } from "@interfaces/vouchers.i";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { BehaviorSubject, Subject, Subscription, combineLatest } from "rxjs";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { RequestBodyService } from "src/app/services/request-body.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { InitialUserContextService } from "src/app/services/initial-user-context.service";
import { VoucherService } from "src/app/services/vouchers.service";
import { ClarityService } from "src/app/services/clarity.service";
import { PosthogService } from "src/app/services/posthog.service";
import { ForgotPasswordPage } from "../forgot-password/forgot-password.page";
import { ResetPasswordPopupComponent } from "../reset-password-popup/reset-password-popup.component";
import { SignupPreventComponent } from "../signup-prevent/signup-prevent.component";
import { SignupSuccessComponent } from "../signup-success/signup-success.component";
import { TermsAndPolicyComponent } from "../terms-and-policy/terms-and-policy.component";
import { VerifyPhoneNumberComponent } from "../verify-phone-number/verify-phone-number.component";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
const { Camera } = Plugins;

@Component({
  selector: "app-signup",
  templateUrl: "./signup.page.html",
  styleUrls: ["./signup.page.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    IonicModule,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    NgClass,
    AsyncPipe,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class SignupPage implements OnInit {
  isSpoofMsn: boolean;
  uid: string;
  resetToken: string;
  private destroy$ = new Subject<void>();
  passwordType = "password";
  passwordIcon = "eye-off";
  signupForm: FormGroup;
  fileToUpload: File = null;
  numberValid = true;
  initialText: string = "LS";
  progressValue = 5;
  prosub: any;
  selectedCurrency: string;
  ipBasedUserCurrency: string;
  userProfilePic$ = new BehaviorSubject(false);
  showInitials$ = new BehaviorSubject(false);
  uploading$ = new BehaviorSubject(false);
  translatedToastMsg: any;
  selectedLanguage: string;
  imagePath$ = new BehaviorSubject("");
  testMsn: number[];
  public userGradeChange: Data;
  localStorage = window.localStorage;
  // fingerPrintId: boolean;
  visitorId: string;
  newPhoneNumber: string;
  newDialCode: string;
  alreadyIpchecked = false;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: true,
  };
  dobDate: any;
  phoneInValid: boolean = false;
  @ViewChild("phoneNumber", { static: true }) phoneNumber: ElementRef;
  public defaultDateOfBirth: string;
  public isDateModalOpen: boolean = false;

  flag: FlagInterface[] = [
    { id: "1", country_code: Language.English, name: "English (default)", img: "../../../assets/images/kingdom.png" },
    { id: "2", country_code: Language.Italian, name: "Italiana", img: "../../../assets/images/italian.png" },
    { id: "3", country_code: Language.German, name: "Deutsche", img: "../../../assets/images/deuch.jpg" },
    { id: "4", country_code: Language.French, name: "Français", img: "../../../assets/images/france.png" },
    { id: "5", country_code: Language.Spanish, name: "Españo la", img: "../../../assets/images/spain.png" },
  ];

  private unsubscribe$ = new Subject<void>();
  languageArray: any[] = [];
  currencyArray: any[] = [];
  private readonly DEFAULT_ENGLISH_LANG = {
    language_code: "en",
    language_name: "English",
    language_status: true,
  };
  private readonly DEFAULT_GBP_CODE = "GBP";
  countryCode: string;
  incorrectPhoneNumber: boolean;
  msn: string;
  subscription: Subscription;
  ipstackCountryCode: string;
  paramsLangCode: Language;
  public translate = inject(TranslateService);
  private posthogService = inject(PosthogService);
  fingerprintPromise: Promise<string | null> | undefined;
  constructor(
    private fb: FormBuilder,
    private actionSheetController: ActionSheetController,
    private bottomSheet: MatBottomSheet,
    private authService: AuthService,
    private firebaseFileUpload: FirebaseFileUploadService,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private modalCtrl: ModalController,
    private voucherService: VoucherService,
    private accountService: AccountRepositoryService,
    private GTMSegment: GTMSegmentService,
    private requestBodyService: RequestBodyService,
    private matDialog: MatDialog,
    private captchaService: CaptchaService,
    private el: ElementRef,
    private renderer: Renderer2,
    private userManagementService: UserManagementService,
    private utilityService: UtilityService,
    private clarityService: ClarityService,
    private initialUserContextService: InitialUserContextService,
  ) {
    this.uid = "";
    // Set FingerprintJSConst vistor ID in it
    try {
        this.fingerprintPromise = Promise
          .resolve(this.authService.fingerprintJS())
          .then((visitorId: string) => {
            CommonVariable.FingerprintJSConst = visitorId;
            return visitorId;
          })
          .catch(err => {
            this.authService.errorHandlerLogs('Failed to initialize fingerprint for signup', err);
            return null;
          });
      } catch (err) {
        this.authService.errorHandlerLogs('Failed to initialize fingerprint for signup (sync)', err);
        this.fingerprintPromise = Promise.resolve(null);
      }
    this.incorrectPhoneNumber = false;

    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        if (this.flag.find((flag) => flag.country_code === l)) {
          this.cell1TelInput.initialCountry = l != defaultLanguage ? l : CommonVariable.countryCode;
        }
        this.translate.use(l ? l : defaultLanguage);
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.GTMSegment.GTMPopupInitialization("SignUp");
    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });

    this.utilityService
      .getLanguageList()
      .pipe(take(1))
      .subscribe(
        (l: Data) => {
          const languages = l?.languages?.filter((lang) => lang?.language_status) ?? [];
          if (!languages.length) {
            this.applyDefaultLanguageOption();
            return;
          }
          const english = languages.filter((lang) => lang?.language_code === "en");
          const rest = languages.filter((lang) => lang?.language_code !== "en");
          this.languageArray = [...english, ...rest];
          this.syncLanguageDropdownSelection();
        },
        () => {
          this.applyDefaultLanguageOption();
        }
      );

    try {
      this.authService.getCurrencyList$?.subscribe(
        (data: any) => {
          try {
            const currencies = data?.details
              ?.filter((currency) => currency.status === true)
              .map((currency) => currency?.currency_code) ?? [];
            if (!currencies.length) {
              this.applyDefaultCurrencyOption();
              return;
            }
            const gbp = currencies.filter((code) => code === "GBP");
            const rest = currencies.filter((code) => code !== "GBP");
            this.currencyArray = [...gbp, ...rest];
            if (!this.ipBasedUserCurrency) {
              this.ipBasedUserCurrency =
                this.currencyArray?.indexOf(this.authService.ipBasedCurrency) < 0
                  ? this.DEFAULT_GBP_CODE
                  : this.authService.ipBasedCurrency;
            }
          } catch (e) {
            console.error("Error processing currency data: ", e);
            this.applyDefaultCurrencyOption();
          }
        },
        () => {
          this.applyDefaultCurrencyOption();
        }
      );

    } catch (e) {
      console.error("Error processing currency data: ", e);
      this.applyDefaultCurrencyOption();
    }

    this.firebaseFileUpload.uploadedPercent$?.subscribe(
      (data) => {
        this.progressValue = data;
      },
      (err) => {
        return err;
      }
    );
/*     this.authService.getTestMsn().subscribe((res: Data) => {
      this.testMsn = res?.msn;
    }); */
    this.dateCalculator();
  }

  ngOnInit() {
    const context = this.initialUserContextService.resolveInitialContext();
    this.selectedLanguage = context.language.value;
    this.paramsLangCode = context.language.value as Language;
    // Push the resolved language into the translate + language streams right away.
    // Setting selectedLanguage alone leaves Translate/selectedlanguage$ lagging until
    // a persisted language_code happens to exist (which no longer occurs for weak provenance).
    const initialLanguage = (this.selectedLanguage || defaultLanguage) as Language;
    this.authService.selectedlanguage$.next(initialLanguage);
    this.translate.use(initialLanguage);
    void this.initialUserContextService.confirmFromIpInBackground();

    // Removed problematic code that extracted dial code from intl-tel-input library's internal DOM
    // element (.iti__selected-dial-code) and set it via setValue(). This was bypassing the library's
    // proper state management and causing malformed event objects, which resulted in ReferenceError
    // in Cloudflare Turnstile. The dial code should be managed through the library's API or the
    // onCell1CountryChange event handler instead.
    this.validateSignUpForm();
    combineLatest([
      this.signupForm.controls.firstName.valueChanges.pipe(startWith("")),
      this.signupForm.controls.lastName.valueChanges.pipe(startWith("")),
    ]).pipe(takeUntil(this.destroy$)).subscribe(
      (formData) => {
        if (formData[0] !== "" && !this.userProfilePic$?.value) {
          this.showInitials$.next(true);

          this.initialText = formData[0][0] + (formData[1][0] ? formData[1][0] : "");
        } else {
          this.showInitials$.next(false);
        }
      },
      (err) => {
        return err;
      }
    );
    const localStorageLanguage: Language = localStorage?.getItem("language_code") as Language;
    if (localStorageLanguage && allLanguageCodes.includes(localStorageLanguage)) {
      this.onLanguageChange(localStorageLanguage);
    } else {
      this.syncLanguageDropdownSelection();
    }
    setTimeout(() => {
      this.dateCalculator();
    }, 100);
    this.GTMSegment.collectVisitorData();
  }
  onLanguageChange(language: Language) {
    language = allLanguageCodes.includes(language) ? language : defaultLanguage;
    const prevLocalLang = localStorage.getItem("language_code") || "";
    this.userManagementService.setUserLanguageLogInFb(prevLocalLang, language, "signup")
    localStorage.setItem("language_code", language);
    this.authService.selectedlanguage$.next(language ? language : defaultLanguage);
    this.translate.use(language);
    this.selectedLanguage = language;
    this.paramsLangCode = language;
    // this.NotificationsService.sendLanguageRequest(language);
  }

  private syncLanguageDropdownSelection(): void {
    if (!this.languageArray?.length) {
      return;
    }

    const availableCodes = this.languageArray.map((language) => language.language_code);
    let current =
      this.selectedLanguage ||
      localStorage.getItem("language_code") ||
      this.initialUserContextService.getContext()?.language.value ||
      defaultLanguage;

    if (!availableCodes.includes(current)) {
      current = availableCodes.includes(defaultLanguage) ? defaultLanguage : availableCodes[0];
      this.onLanguageChange(current as Language);
      return;
    }

    this.selectedLanguage = current;
    this.paramsLangCode = current as Language;
  }

  private applyDefaultLanguageOption(): void {
    this.languageArray = [this.DEFAULT_ENGLISH_LANG];
    this.syncLanguageDropdownSelection();
  }

  private applyDefaultCurrencyOption(): void {
    this.currencyArray = [this.DEFAULT_GBP_CODE];
    if (!this.ipBasedUserCurrency || !this.currencyArray.includes(this.ipBasedUserCurrency)) {
      this.ipBasedUserCurrency = this.DEFAULT_GBP_CODE;
    }
    this.selectChange(this.ipBasedUserCurrency);
  }

  selectChange(currency: string) {
    this.userManagementService.selectedCurrency = currency;
    this.ipBasedUserCurrency = currency;
  }

  hideShowPassword(): void {
    this.passwordType = this.passwordType === "text" ? "password" : "text";
    this.passwordIcon = this.passwordIcon === "eye" ? "eye-off" : "eye";
  }

  showErrorTostMsg(error: Data) {
    if (error.message == "This user is already registered, please login with correct password.") {
      this.openForgetPassword();
    }
    const translatedMsg = {
      message: {
        line_1: error?.message,
        line_2: "",
      },
      style: {
        duration: 2000,
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    const defaultMsg = {
      message: {
        line_1: "We couldn't create your account. Try again.",
        line_2: "",
      },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    this.authService.showToastMessage(translatedMsg, defaultMsg);
  }
  onSignupFormSubmit() {
    //  Test MSN Cheacks
    const testMsnAvailable = this.testMsn?.includes(this.signupForm?.value?.phoneNumber.slice(1));

    // if (this.fingerPrintId === true && testMsnAvailable === false) {
    //   this.opentriggerInfo();
    // }

    if (testMsnAvailable === true) {
      this.opentriggerInfo();
    }

    if (this.signupForm.valid || testMsnAvailable === false) {
      this.twillioValidation()?.subscribe(
        (twilioData: any) => {
          if (twilioData.success) {
            this.signupForm.value.preferred_currency = this.userManagementService?.selectedCurrency
              ? this.userManagementService?.selectedCurrency
              : "GBP";
            // this.signupForm.value.preferred_currency = "GBP";
            this.authService
              .signup(this.signupForm.value)
              .pipe(take(1))
              .subscribe(
                (res) => {
                  if (!res.success) {
                    this.showErrorTostMsg(res);
                  } else {
                    if (res.success === true && res?.user?.user_id) {
                      localStorage.setItem('preferred_currency_code', this.userManagementService?.selectedCurrency ?? "GBP");
                      this.authService.breakDownVisited(false);
                      // dublicate device detection
                      this.deviceDuplicationDetection();
                      // Success signup tracking
                      this.GTMSegment.collectVisitorData("", "", 1, 1);
                      // Upload User Fingerprint Information during signup to use it for fraud detection and security purposes
                      this.userManagementService.uploadUserFingerprintInfo(res?.user?.user_id, CommonVariable.FingerprintJSConst);
                    }
                    const cred: AuthCredentials = {
                      phoneNumber: this.signupForm?.value?.phoneNumber,
                      password: this.signupForm.get("password").value,
                      udId: "",
                      language_code: "",
                      preferred_currency: this.userManagementService?.selectedCurrency,
                      // preferred_currency: "GBP",
                      prosub_id: "",
                      tp1:
                        this.prosub && this.prosub.params && this.prosub.params.TP1
                          ? this.prosub.params.TP1?.toLowerCase()
                          : "",
                      tp2:
                        this.prosub && this.prosub.params && this.prosub.params.TP2
                          ? this.prosub.params.TP2?.toLowerCase()
                          : "",
                      tp3:
                        this.prosub && this.prosub.params
                          ? this.prosub.params.TP3
                            ? this.prosub.params.TP3?.toLowerCase()
                            : this.prosub.params[
                              Object.keys(this.prosub.params)?.find((key) => key?.toLowerCase() === "tp3")
                            ]?.toLowerCase() ?? ""
                          : "",
                      t_id:
                        this.prosub && this.prosub.params
                          ? this.prosub.params.T_ID
                            ? this.prosub.params.T_ID?.toLowerCase()
                            : this.prosub.params[
                              Object.keys(this.prosub.params)?.find((key) => key?.toLowerCase() === "t_id")
                            ]?.toLowerCase() ?? ""
                          : "",
                      other: "",
                    };

                    if (res.existingUser) {
                      /* const msg = this.translatedToastMsg?.["1077"]?.[this.selectedLanguage];
                    this.authService.showToast(msg ? msg : "User already registered with us, logging you in", "success", ""); */
                      this.authService
                        .getConstantsMsg("1077")
                        .then((translatedMsg) => {
                          const defaultMsg = {
                            message: {
                              line_1: "You already have an account. We're logging you in.",
                              line_2: "",
                            },
                            style: {
                              icon: "tick circle success.png",
                              type: "Success",
                            },
                          };
                          this.authService.showToastMessage(translatedMsg, defaultMsg);
                        })
                        .catch((error) => {
                          return error;
                        });

                      this.authService.tryLoginWithCred(cred);
                      return;
                    }
                    this.clarityService.event("sign_up_complete");
                    // HATDEV-100772: pass user_id — Auth currentUser often not ready yet on /signup
                    this.posthogService.emitRegistrationCompleted(
                      "signup_sign_up_complete",
                      res?.user?.user_id
                    );
                    this.signupSuccessHandler(cred);
                  }
                },
                async (error) => {
                  // Failure signup tracking
                  this.GTMSegment.collectVisitorData("", "", 1, 0);
                  this.showErrorTostMsg(error);
                }
              );
          } else {
            /* const msg = this.translatedToastMsg?.["1078"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "please enter a valid mobile number", "error", ""); */
            this.authService
              .getConstantsMsg("1078")
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Enter a valid mobile number",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((err) => {
                return err;
              });
          }
        },
        (err) => {
          // Failure Twilio / pre-signup validation tracking
          this.GTMSegment.collectVisitorData("", "", 1, 0);
          return err;
        }
      );
    }
    if (this.signupForm.value?.preference != null && this.signupForm.value?.preference != undefined) {
      localStorage.setItem("preferenceTick", this.signupForm.value?.preference);
    } else {
      throw new Error("preference not set");
    }
  }

  private validateSignUpForm() {
    this.signupForm = this.fb.group(
      {
        firstName: ["", Validators.compose([Validators.required, Validators.minLength(1)])],
        lastName: ["", Validators.compose([Validators.required, Validators.minLength(3)])],
        email: [
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
          ]),
        ],
        cemail: [
          "",
          Validators.compose([
            Validators.required,
            Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"),
          ]),
        ],
        password: ["", Validators.compose([Validators.required, Validators.minLength(6)])],
        agreeToTerms: [true, Validators.requiredTrue],
        phoneNumber: ["", Validators.compose([Validators.required, Validators.maxLength(11)])],
        profile_picture: ["assets/images/usericon_profile_signup.svg"],
        language_code: this.translate.currentLang,
        preferred_currency: [""],
        dateOfBirth: ["", Validators.compose([this.dateOfBirthValidation.bind(this)])],
        preference: [false],
        dialCode: ["", Validators.required],
      },
      { updateOn: "blur" }
    );
    this.signupForm.addValidators(matchValidator(this.signupForm.get("email"), this.signupForm.get("cemail")));
  }

  /* profile image selection */
  async selectImage() {
    const actionSheet = await this.actionSheetController.create({
      header: "Add profile picture",
      mode: "ios",
      buttons: [
        {
          text: "Gallery",
          handler: () => {
            let element: HTMLElement = document.getElementById("selectBtn") as HTMLElement;
            if (element) {
              element.click();
            } else {
              console.warn("selectBtn element not found");
            }
          },
        },
        {
          text: "Camera",
          handler: () => {
            this.ngZone.run(() => {
              Camera.requestPermissions()
                .then(() => {
                  this.requestImage(1);
                })
                .catch((error) => {
                  return error;
                });
            });
          },
        },
        {
          text: "Remove Photo",
          handler: () => {
            this.ngZone.run(() => {
              this.uploading$.next(false);
              this.userProfilePic$.next(false);
              this.showInitials$.next(false);
            });
          },
        },
        {
          text: "Cancel",
          role: "cancel",
        },
      ],
    });
    await actionSheet.present();
  }

  private requestImage(type: number) {
    Camera.getPhoto({
      resultType: CameraResultType.DataUrl,
      allowEditing: true,
      quality: 100,
    })
      .then((imageData) => {
        this.uploadProfilePicBase64(imageData);
      })
      .catch((err) => {
        return err;
      });
  }

  private uploadProfilePicBase64(blob: any) {
    this.uploading$.next(true);
    this.firebaseFileUpload
      .updateProfileImageUsingBase64(blob, "profilePicture/")
      .then((imageName: string) => {
        this.signupForm.controls.profile_picture.setValue(
          FB_PROFILE_PIC_BASE_URL + this.getFileNameWithResolution(imageName) + "?alt=media"
        );
        this.imagePath$.next(FB_PROFILE_PIC_BASE_URL + this.getFileNameWithResolution(imageName) + "?alt=media");
        setTimeout(() => {
          this.uploading$.next(false);
          this.showInitials$.next(false);
          this.userProfilePic$.next(true);
        }, 5000);
      })
      .catch((err) => {
        return err;
      });
  }

  showTerms() {
    /* To show the terms and condition Pop up */
    const showTermsAndCondition = this.bottomSheet.open(TermsAndConditionPage, {
      panelClass: "terms-dialog",
    });
  }

  showPolicy(contentType: string) {
    /* To show the terms and policy Pop up */
    const privacyPolicy = this.bottomSheet.open(TermsAndConditionPage, {
      panelClass: "terms-dialog",
      data: { contentType: contentType, signup: true },
      backdropClass: "terms-dialog-backdrop",
    });
  }
  async showTermsPolicy(contentType: string) {
    const showTermsAndCondition = this.bottomSheet.open(TermsAndPolicyComponent, {
      panelClass: "terms-dialog",
      data: { contentType: contentType },
    });
  }

  // ng2TelInput Events
  // IMO, this component is not very good.
  // Better Alternatives: https://github.com/webcat12345/ngx-intl-tel-input#readme
  getPhoneNumber(event) {
    this.newPhoneNumber = event?.target?.value;
    // Enforce maximum length of 11 characters for phoneNumber
    const maxLength = 11;
    if (this.newPhoneNumber.length > maxLength) {
      this.newPhoneNumber = this.newPhoneNumber.slice(0, maxLength);
    }
    // Validate phone number format (you can customize this validation based on your needs)
    const phoneNumberRegex = /^0?\d+$/; // Only allow digits
    const isPhoneNumberValid = phoneNumberRegex.test(this.newPhoneNumber);

    // Always set the combined value to phoneNumber without the dial code
    const displayedPhoneNumber = this.newPhoneNumber; // Only the phone number without dial code
    this.signupForm.get("phoneNumber").setValue(displayedPhoneNumber);

    // Set or clear the error based on the phone number validity
    if (!isPhoneNumberValid) {
      this.signupForm.get("phoneNumber").setErrors({ incorrectPhoneNumber: true });
    } else {
      this.signupForm.get("phoneNumber").setErrors(null);
    }
  }

  phoneNumberHasError(hasError: boolean) {
    this.incorrectPhoneNumber = hasError;
    this.signupForm.get("phoneNumber").setErrors({
      incorrectPhoneNumber: !hasError,
    });
    this.phoneInValid = this.phoneNumber.nativeElement.value ? true : false;
  }

  getCurrentProfilePic() {
    if (!this.signupForm.get("profile_picture").value) return;
    return this.signupForm.get("profile_picture").value;
  }

  imageUpload(selectedFile: any) {
    this.uploading$.next(true);
    if (selectedFile && selectedFile?.length !== 0) {
      this.firebaseFileUpload.updateProfileImage(selectedFile, "profilePicture/").then(
        (res: any) => {
          this.signupForm?.controls?.profile_picture.setValue(
            FB_PROFILE_PIC_BASE_URL + this.getFileNameWithResolution(res) + "?alt=media"
          );
          this.imagePath$.next(FB_PROFILE_PIC_BASE_URL + this.getFileNameWithResolution(res) + "?alt=media");
          setTimeout(() => {
            this.uploading$.next(false);
            this.showInitials$.next(false);
            this.userProfilePic$.next(true);
          }, 5000);
        },
        (err) => {
          /* const msg = this.translatedToastMsg?.["1082"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "Profile Image Update Failed", "error", ""); */
          this.authService
            .getConstantsMsg("1082")
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Your account was created, but we couldn't upload your profile picture. You can add it later.",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((err) => {
              return err;
            });

          return err;
        }
      );
    }
  }

  numericOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  numberValidation() {
    if (
      this.signupForm.get("phoneNumber").value &&
      (String(this.signupForm.get("phoneNumber").value)?.length === 10 ||
        String(this.signupForm.get("phoneNumber").value)?.length === 11)
    ) {
      this.numberValid = true;
    } else {
      this.numberValid = false;
    }
  }

  private getFileNameWithResolution(imageName: string): string {
    if (!imageName) return;
    return UtilityService.insertString(imageName?.split(".")[0]?.length, "_200x200", imageName);
  }

  signupSuccessHandler(cred: any) {
    const successDialog = this.dialog.open(SignupSuccessComponent, {
      panelClass: "dialog-size-voucher",
    });

    successDialog.afterClosed().subscribe(
      () => {
        setTimeout(() => {
          this.ProfilePicUpdateToSql();
        }, 8000);
        this.authService
          .tryLoginWithCred(cred, true)
          .then(() => {
            this.GTMSegment.collectVisitorData(null, null, 1, 1);
          })
          .catch((error) => {
            this.GTMSegment.collectVisitorData(null, null, 1, 0);
            return error;
          });
      },
      (err) => {
        return err;
      }
    );
  }
  goBack() {
    this.modalCtrl.dismiss().catch((err) => {
      return err;
    });
  }

  onlyAlpha(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    }
    return false;
  }

  private twillioValidation() {
    // Check if the dial code is not present, then add it
    if (this.signupForm?.value?.phoneNumber.startsWith("0")) {
      this.signupForm.value.phoneNumber = this.signupForm?.value?.phoneNumber.substring(1);
    }

    if (!this.signupForm.value.phoneNumber.startsWith(this.signupForm?.value?.dialCode)) {
      this.signupForm.value.phoneNumber = this.signupForm?.value?.dialCode + this.signupForm?.value?.phoneNumber;
    }
    if (!this.signupForm?.value?.phoneNumber) return;
    let phoneNumber = this.signupForm?.value?.phoneNumber;
    return this.authService.validateTwilio(phoneNumber);
  }

  updateReferralCodeToVoucher(voucherCode) {
    this.voucherService
      .redeemVoucher(voucherCode, "", "")
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (voucherResponse: VoucherClaimResult) => {
          if (voucherResponse?.status === "1") {
            /* const msg = this.translatedToastMsg?.["1016"]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : "The Invitation has been successfully accepted", "Success", ""); */
            this.authService.getConstantsMsg("1016").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Invitation accepted.",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            });
          } else {
            //this.authService.showToast(voucherResponse.message ? voucherResponse.message : "Something went wrong!", "Error", "");
            const translatedMsg = {
              message: {
                line_1: voucherResponse?.message,
                line_2: "",
              },
              style: {
                duration: 2000,
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            const defaultMsg = {
              message: {
                line_1: "We couldn't apply that invitation code. Check the code and try again.",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          }
        },
        error: (error) => {
          return error;
        },
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    // Unsubscribing from the Observable when the component is destroyed
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  ProfilePicUpdateToSql() {
    if (this.imagePath$.value) {
      this.requestBodyService.checkApiPostReqProfileImg = false;
      this.requestBodyService.checkApiPostReqRemovePhoto = false;
      this.accountService.updateProfileImage(this.imagePath$.value).subscribe(
        () => {
          /*  const msg = this.translatedToastMsg?.["1017"]?.[this.selectedLanguage];
           this.authService.showToast(msg ? msg : "Profile picture updated", "Success", ""); */
          this.authService
            .getConstantsMsg("1017")
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Profile picture updated.",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
        },
        (err) => {
          return err;
        }
      );
    }
  }
  onDateChange(event: any) {
    const value = event?.detail?.value;
    const control = this.signupForm.get('dateOfBirth');
    if (!value || !control) return;
    const formattedDate = moment(value).format('MM/DD/yyyy');
    control.setValue(formattedDate);
    this.dobDate = value;
    this.defaultDateOfBirth = value;
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();
  }

  /**
   * Open date picker modal when input is clicked
   */
  openDateModal(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.isDateModalOpen) return;

    this.isDateModalOpen = true;
    const control = this.signupForm.get('dateOfBirth');
    control?.markAsTouched();
    control?.updateValueAndValidity();
  }


  /**
   * Close date picker modal
   * Called when backdrop is clicked or date is selected
   */
  closeDateModal() {
    this.isDateModalOpen = false;
  }
  // FringerprintJS Function
  async fingerprintJS() {
    // try {
    //   const fpPromise = await FingerprintJS.load();
    //   const fp = await fpPromise;
    //   const result = await fp.get();
    //   this.visitorId = result.visitorId;
    //   this.getFringerPrintData(result.visitorId);
    //   return result.visitorId;
    // } catch {
    //   return null;
    // }
  }
  opentriggerInfo() {
    this.matDialog.open(SignupPreventComponent, {
      panelClass: "app-signup-prevent",
      backdropClass: "decline-back-drop-color",
      hasBackdrop: true,
    });
  }
  getFringerPrintData(visitorId: string) {
    // this.authService?.getfringserPrintId(visitorId).subscribe((data: Data) => {
    //   if (data) {
    //     this.fingerPrintId = true;
    //   }
    // });
  }

  // This function takes in a form control (control) and checks if the date is less than 18.
  // If the date is less than 18, it will return a futureInvalidDate error.
  // Otherwise, it will return null.
  dateOfBirthValidation(control: FormControl) {
    if (control.value) {
      let now = new Date();
      let dob = new Date(control.value);
      // This condition will check the date of birth is greater or equal to 18
      const eighteenYearsAgo: Date = new Date();
      eighteenYearsAgo.setFullYear(now.getFullYear() - 18);
      if (dob >= eighteenYearsAgo) {
        return { futureInvalidDate: true };
      }
    }
    return null;
  }
  public autoFill(event, type) {
    const autoFillValue = event?.target?.value;
    // Set the value
    this.signupForm.get(type).setValue(autoFillValue);
    if (type === "firstName") {
      this.signupForm.get(type).setValue(autoFillValue);
    } else if (type === "lastName") {
      this.signupForm.get(type).setValue(autoFillValue);
    }
  }

  flagsDropdownToggle(value: boolean) {
    CommonVariable.flagsDropdownOpened = value;
  }

  onCell1CountryChange(event) {
    // Extract event data outside Angular zone to prevent Java bridge errors on Android WebView
    this.countryCode = event.iso2;
    this.newDialCode = event?.dialCode;
    
    // Process the form update inside Angular zone to ensure proper event handling
    this.ngZone.run(() => {
      this.signupForm.get("dialCode").setValue(this.newDialCode);
    });
  }

  openForgetPassword() {
    const forgotPasswordDialog = this.bottomSheet.open(ForgotPasswordPage, {
      panelClass: "forgot-password-bottomsheet",
      hasBackdrop: true,
      disableClose: true,
      backdropClass: "about-product-dialog-backdrop",
      data: {
        countryCode: this.countryCode,
        mobileNumber: this.incorrectPhoneNumber ? this.signupForm.get("phoneNumber")?.value : "",
      },
    });
    try {
      forgotPasswordDialog?.afterDismissed()?.subscribe(
        (res: any) => {
          if (res === undefined) {
            return;
          }
          if (res) {
            this.openVerifyPhoneNumber(res);
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) { }
  }

  openVerifyPhoneNumber(res) {
    this.msn = res?.msn;
    const verifyPhoneNoBottomSheet = this.bottomSheet.open(VerifyPhoneNumberComponent, {
      panelClass: "verify-phone-number-bottom-sheet",
      disableClose: true,
      data: {
        msn: res?.msn,
        type: "signin",
        loginWithMsn: true,
      },
    });
    try {
      verifyPhoneNoBottomSheet?.afterDismissed()?.subscribe(
        (data) => {
          if (data) {
            this.msn = data?.data?.msn ?? res?.msn;
            if (data?.data?.spoof_msn) {
              this.isSpoofMsn = data?.data?.spoof_msn;
            }
            if (data?.data?.uid) {
              this.uid = data?.data?.uid;
            }
            if (data?.resetToken) {
              this.resetToken = data.resetToken;
            }
            // this.resetPassword();
            // Reset password and login, we are bypassing the ResetPasswordPage here
            this.onResetPassword();
          } else if (data === false) {
            this.captchaService?.otpSent$.next(false);
            /*  const msg = this.translatedToastMsg?.["1010"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "OTP doesn't match.", "Error", ""); */
            this.authService
              ?.getConstantsMsg("1010")
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "That verification code is incorrect. Check the code and try again.",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService?.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                return error;
              });
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }

  resetPassword(): void {
    this.bottomSheet.open(ResetPasswordPopupComponent, {
      disableClose: true,
      data: { msn: this.msn, resetToken: this.resetToken },
    });
  }

  async onResetPassword() {
    try {
      await this.authService.resetPasswordAndRedirectToNextPage(this.msn, this.signupForm.value.password, "signup", this.resetToken);
    } catch (error) {
      return error;
    }
  }

  dateCalculator() {
    const today = new Date();

    // Calculate the date 18 years ago from today
    const minDOB = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

    // Format the minimum date for the input field
    this.defaultDateOfBirth = minDOB.toISOString().split("T")[0];
  }
  ngAfterViewInit() {
    this.hideElements();
    this.updateContainerStyle();
    try {
      this.subscription = this.userManagementService
        .getUserCountryBaseOnIP()
        .pipe(
          switchMap((res: Data) => {
            const countryCode = res?.country_code ?? "GB";
            this.ipstackCountryCode =
              "+" + (res?.location?.calling_code ? res?.location?.calling_code : CommonVariable.defaultDialCode);
            this.signupForm?.get("dialCode")?.setValue(this.ipstackCountryCode);
            return this.authService.getCurrencyAndLanguageList$.pipe(
              map((data: Data) => {
                const countriesArray = Object.keys(data);
                if (countryCode !== "" && countriesArray.includes(countryCode)) {
                  return data[countryCode] ?? data["GB"];
                } else {
                  return data["GB"];
                }
              })
            );
          })
        )
        .subscribe(
          (data: Data) => {
            if(this.alreadyIpchecked) return
            this.alreadyIpchecked = true;
            this.ipBasedUserCurrency = data?.currency ?? "GBP";
            this.paramsLangCode = data?.language ?? "en";
            this.selectChange(this.ipBasedUserCurrency);
            const locallnaguage = this.localStorage?.getItem("language_code") ?? data?.language;
            this.onLanguageChange((locallnaguage ?? "en") as Language);
            this.syncLanguageDropdownSelection();
          },
          (err) => {
            return err;
          }
        );
    } catch (err) {
      return err;
    }
  }
  private hideElements() {
    const elementsToHide = this.el.nativeElement.querySelectorAll(".iti__flag.iti__gb");
    elementsToHide.forEach((element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.style.setProperty("display", "none", "important");
    });

    // Set a specific width for the container
    const container = this.el.nativeElement.querySelector(".iti.iti--allow-dropdown"); // Replace with the actual container class or element selector
    if (container) {
      const containerElement = container as HTMLElement;
      containerElement.style.width = "10%";
    }
  }
  updateContainerStyle(): void {
    const container = this.el.nativeElement.querySelector(
      ".iti--allow-dropdown .iti__flag-container, .iti--separate-dial-code .iti__flag-container"
    );

    if (container) {
      this.renderer.setStyle(container, "right", "20%");
    }
  }
  checkInput(e) {
    let value;
    const currentInput = e.target.value;
    const DEFAULT_VALUE = "+";
    const currentInputDefaultPart = currentInput.substring(0, DEFAULT_VALUE.length);
    // check if the default part is no longer same as DEFAULT
    if (currentInputDefaultPart !== DEFAULT_VALUE) {
      // reset
      value = DEFAULT_VALUE;
      this.signupForm.get("dialCode").setValue(value);
    }
  }
  // Function to detect device duplication
  async deviceDuplicationDetection() {
     // Ensure fingerprint is ready before proceeding
      let visitorId: string | null = CommonVariable.FingerprintJSConst ?? null;
      if (!visitorId && this.fingerprintPromise) {
      // Wait for fingerprint generation if still in progress
        visitorId = await this.fingerprintPromise;
      }
      if (!visitorId) {
        // Optionally: 
        this.authService.errorHandlerLogs('No fingerprint available for duplication check');
        return;
      }
    if (visitorId) {
      // Make a request to check if the fingerprint exists in the database
      this.authService.getFingerprintId(visitorId).subscribe((res: Data) => {
        // Extract the user ID from the response
        if (!res) return;
        if (res.userId.length > 1 && Array.isArray(res.userId)) {
          const userID = res?.userId[0];
          // Assign a default value to userGradePoints (e.g., 5)
          const userGradePoints = 5;
          // Prepare data to update user grade
          const data = {
            user_id: userID,
            user_grade: userGradePoints,
          };
          // Call a cloud function to update user grade
          this.authService.getV2CloudFunction("updateusergradev2", data)?.subscribe(
            (res: Data) => {
              // Success callback
              this.userGradeChange = res?.response?.status;
            },
            (error) => {
              // Error callback for cloud function
              return error;
            }
          );
        }
      });
    }
  }
}
function matchValidator(control: AbstractControl, controlTwo: AbstractControl): ValidatorFn {
  return () => {
    if (control.value !== controlTwo.value) return { match_error: true };
    return null;
  };
}
